module.exports = __webpack_public_path__ + "media/paris-screen-video.9233586e.webm";